import $ from 'jquery';
import StoreSession from './session';
import axios from 'axios';


const SELECTORS = {
    paginationCountProducts: '#paginationCountProducts [data-perpage]',
    productSortItem: '#productSort [data-sort]',
    productSortOptions: '#productSort ul li>[data-sort]',
    productSortMobileToggle: '#productSort [data-bs-target="#sorting_modal"]',
    productSortingForm: '#product_sorting',
    productSortingInput: '#product_sorting input[name="sort"]',
    productSortingCheckedInput: '#product_sorting input[name="sort"]:checked',
    listingDropdownToggle: '.drop-sort [data-toggle="dropdown"]',
    productListViewModeToggle: '[data-product-view-mode][data-bs-toggle="tab"]',
    dropdownSort: '#dropdownMenuCatalogOrder',
    dropdownPerPage: '#dropdownMenuCatalogPerPage span'
};

const PARAMS = {
    productViewModeStorageId: 'productListViewMode',
    productSortStorageId: 'productListSort',
    maxPerPage: 'max_per_page',
    sort: 'sort'
};

const parseQueryToState = searchParams => ({
    maxPerPage: searchParams ? searchParams.get(PARAMS.maxPerPage) : null,
    sort: searchParams ? searchParams.get(PARAMS.sort) : null
});

const updateSortDropdownLabel = sort => {
    $(SELECTORS.productSortOptions).each((_, element) => {
        if ($(element).attr('data-sort') === sort) {
            $(SELECTORS.dropdownSort).html($(element).html());
            $(SELECTORS.productSortMobileToggle).html($(element).html());
        }
    });
};

const getAvailableSorts = () => $(SELECTORS.productSortOptions)
    .map((_, element) => $(element).attr('data-sort'))
    .get();

const saveSort = sort => {
    if (sort) {
        localStorage.setItem(PARAMS.productSortStorageId, sort);
    }
};

const restoreSort = (params, availableSorts) => {
    const savedSort = localStorage.getItem(PARAMS.productSortStorageId);

    if (!savedSort || !availableSorts.includes(savedSort)) {
        return null;
    }

    params.set(PARAMS.sort, savedSort);

    return savedSort;
};

const updatePerPageDropdownLabel = maxPerPage => {
    if (maxPerPage) {
        $(SELECTORS.dropdownPerPage).html(maxPerPage);
    }
};

const closeListingDropdowns = (currentMenu = null) => {
    $('.drop-sort > .dropdown-menu.show').each(function () {
        if (currentMenu && this === currentMenu[0]) {
            return;
        }

        $(this)
            .removeClass('show')
            .siblings('[data-toggle="dropdown"]')
            .attr('aria-expanded', 'false');
    });
};

const initListingDropdowns = () => {
    document.addEventListener('click', event => {
        const target = event.target.closest(SELECTORS.listingDropdownToggle);
        if (!target) {
            return;
        }

        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();

        const toggle = $(target);
        const menu = toggle.siblings('.dropdown-menu').first();

        if (menu.length === 0) {
            return;
        }

        const willShow = !menu.hasClass('show');

        closeListingDropdowns(menu);
        menu.toggleClass('show', willShow);
        toggle.attr('aria-expanded', willShow ? 'true' : 'false');
    }, true);
};

/**
 * Инициализировать управление списком (сортировка и на странице).
 */
export const initListingControls = () => {
    const currentUrl = new URL(window.location.href);
    const params = currentUrl.searchParams;
    const { maxPerPage, sort } = parseQueryToState(params);
    const availableSorts = getAvailableSorts();

    if (sort && availableSorts.includes(sort)) {
        saveSort(sort);
    } else if (!sort) {
        const restoredSort = restoreSort(params, availableSorts);

        if (restoredSort) {
            window.location.replace(currentUrl.toString());
            return;
        }
    }

    updateSortDropdownLabel(sort);
    updatePerPageDropdownLabel(maxPerPage);
    initListingDropdowns();

    $(document).on('click', SELECTORS.paginationCountProducts, event => {
        event.preventDefault();
        const pageCount = $(event.currentTarget).attr('data-perPage');

        if (maxPerPage) {
            params.set(PARAMS.maxPerPage, pageCount);
        } else {
            params.append(PARAMS.maxPerPage, pageCount);
        }

        closeListingDropdowns();
        updatePerPageDropdownLabel( pageCount );
        window.location.href = currentUrl.toString();
    });

    $(document).on('click', SELECTORS.productSortItem, event => {
        event.preventDefault();
        const dataSort = $(event.currentTarget).attr('data-sort');

        params.set(PARAMS.sort, dataSort);
        saveSort(dataSort);
        closeListingDropdowns();
        updateSortDropdownLabel(dataSort);
        window.location.href = currentUrl.toString();
    });

    $(document).on('submit', SELECTORS.productSortingForm, event => {
        event.preventDefault();
        const dataSort = $(SELECTORS.productSortingCheckedInput).val();

        if (!dataSort) {
            return;
        }

        params.set(PARAMS.sort, dataSort);
        saveSort(dataSort);
        $(SELECTORS.productSortingInput).prop('disabled', true);
        window.location.href = currentUrl.toString();
    });


    $( SELECTORS.productListViewModeToggle ).click( function (e) {
/*        const elTab = $( $(this).data('bs-target') );

        if( elTab.attr('data-view-lazy-url') ) {
            axios.get( elTab.data('view-lazy-url'))
              .then(function (response) {
                elTab.html( response.data );                
              });
        }*/

        localStorage.setItem( PARAMS.productViewModeStorageId, $(this).data('product-view-mode') );
        StoreSession( [ PARAMS.productViewModeStorageId ] );
    })
};
